import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthentication } from '../../contexts/AuthContext';
import { IUserDetails } from '../../services/UserService/types';

interface AdminProtectedRouteProps {
  requiredMenus?: string[];
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ requiredMenus = [] }) => {
  const { sessionToken } = useAuthentication();
  const userDetails: IUserDetails = sessionToken?.user as unknown as IUserDetails || {} as IUserDetails;
  
  // If no specific menus are required, just check if the user is an admin
  if (requiredMenus.length === 0) {
    return <Outlet />;
  }
  
  // Super admin has access to everything
  if (userDetails?.isSuperAdmin) {
    return <Outlet />;
  }
  
  // Check if user has at least one of the required menu permissions
  const hasPermission = requiredMenus.some(menu => 
    userDetails?.menus?.includes(menu)
  );
  
  const handlePermissionError = () => {
    return (
      <div className="flex justify-center items-center w-auto h-screen font-semibold text-xl text-gray-500">
        You do not have permission to view this page.
      </div>
    );
  };

  // If user has permission, render the child routes, otherwise show 404
  return hasPermission ? <Outlet /> : handlePermissionError();
};

export default AdminProtectedRoute;